/** CRM-aligned logo sizing: fixed height, natural width, never squash in square boxes. */
const LOGO_HEIGHTS = {
  xs: 26,
  sm: 32,
  md: 44,
  lg: 64,
};

function logoImageSx(height = LOGO_HEIGHTS.md) {
  return {
    height,
    width: "auto",
    maxWidth: "none",
    minWidth: 0,
    objectFit: "contain",
    display: "block",
    flexShrink: 0,
  };
}

export { LOGO_HEIGHTS, logoImageSx };
